import {Pipe, PipeTransform} from '@angular/core'
import {MessageService} from '../../core/service/message.service'
import {Messages} from '../../core/model/message.model'

@Pipe({
  name: 'm',
})
export class MessagePipe implements PipeTransform {

  constructor(private messageService: MessageService) {
  }

  /**
   * Usage:
   * {{(''|m).some_key_message}}
   * It could seems weird but it allows auto completion, error on compilation and got better performance
   * than typical API of kind:
   * 'some.key_message' | m
   */
  transform(value?: any): Messages {
    return this.messageService.messages
  }

  // Typical API
  // private resolve(path, obj = self, separator = '.') {
  //   const properties = Array.isArray(path) ? path : path.split(separator)
  //   return properties.reduce((prev, curr) => prev && prev[curr], obj)
  // }
}
